<style rel = "stylesheet" type = "text/css" media = "print" >
      @media print {
    .printPageButton {
          display: none;
    }
}
</style>

<div id="demo">
<altSurvey-header *ngIf="goToDetails || goToQuestions || expire || thanks" [pageHeaderResponseJSON]="pageHeaderResponseJSON"></altSurvey-header>
<error-page *ngIf="error"></error-page>
<thank-you *ngIf="thanks"></thank-you>
<expire *ngIf="expire"></expire>
<loading *ngIf="loading"></loading>
<welcome-page [error]="error" [loading]="loading" [thanks]="thanks" [expire]="expire" *ngIf="goToDetails" [wCPageDetailsResponseJSON]="wCPageDetailsResponseJSON" 
      (parentEmitter)="changePage($event)"></welcome-page>
<!--<questions-page *ngIf="goToQuestions" [questionDetailsHeaderRequestJSON]="questionDetailsHeaderRequestJSON"></questions-page>-->
<questions-page [error]="error" [loading]="loading" [thanks]="thanks" [expire]="expire" *ngIf="goToQuestions" [surveyDeployerQuestionPageRequestJSON]="surveyDeployerQuestionPageRequestJSON"></questions-page>
<altSurvey-footer *ngIf="goToDetails || goToQuestions || expire || thanks" [pageFooterResponseJSON]="pageFooterResponseJSON"></altSurvey-footer>
</div>

<div class="form-group text-center form-footer fixedBTN fixedBTN_print" *ngIf="showPrintButton">
      <button id=""  class="btn btn-purple printPageButton"  (click)=printCurrentPage() >print</button>
</div>
<br/>